import { Maybe, TODO, Timestamp } from '@b2b/types/core';
import uiRouter from '@uirouter/angularjs';
import angular, { IScope, ITimeoutService } from 'angular';
import { SubscriptionsListServiceModule } from './SubscriptionsList.service';

SubscriptionsListStartDatePickerController.$inject = [
  '$scope',
  '$timeout',
  'UserPreferencesService',
  'SubscriptionsListService',
];

function SubscriptionsListStartDatePickerController(
  $scope: IScope & { subscriptionsListDatePicker: TODO; dt: Maybe<Date>; minDate: Maybe<Date> },
  $timeout: ITimeoutService,
  UserPreferencesService: TODO,
  SubscriptionsListService: TODO
) {
  const ctrl = {
    isOpen: false,
    dt: null as Maybe<Date>,

    dateOptions: {
      formatYear: 'yy',
      startingDay: UserPreferencesService.getStartDayOfWeek(),
      formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
      showWeeks: false,
    } as {
      formatYear: 'yy';
      startingDay: number;
      formatDayTitle: any;
      showWeeks?: boolean;
      maxDate?: Timestamp;
    },

    isPreferenceLoaded: false,

    init: function () {
      $scope.$on('UserPreferencesService:onDateFormatLoad', ctrl.onDateFormatLoad);
      $timeout(function () {
        ctrl.isPreferenceLoaded = true;
      }, 0);
    },

    today: function () {
      ctrl.dt = new Date();
    },
    clear: function () {
      $scope.dt = null;
    },

    toggleMin: function () {
      $scope.minDate = $scope.minDate ? null : new Date();
    },

    open: function ($event) {
      $event.preventDefault();
      $event.stopPropagation();

      ctrl.dateOptions.maxDate = SubscriptionsListService.getEndDate();

      ctrl.isOpen = true;
    },

    onDateFormatLoad: function (e, data) {
      ctrl.dateOptions = {
        formatYear: 'yy',
        startingDay: UserPreferencesService.getStartDayOfWeek(),
        formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
      };
    },
  };

  $scope.subscriptionsListDatePicker = ctrl;
  ctrl.init();
}

export const SubscriptionsListStartDatePickerControllerModule = angular
  .module('acme.view.application.subscriptions.list.startDatePicker.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.userPreferences',
    SubscriptionsListServiceModule,
    'acme.common.service.userPreferences',
  ])

  .controller('SubscriptionsListStartDatePickerController', SubscriptionsListStartDatePickerController).name;
